<!-- @if (splashScreen || uiService.maintenanceMode) { -->
<!-- <app-splash-screen [@slideDownNoOpacity]></app-splash-screen> -->
<!-- } -->
<div class="bg">
  <img [ngSrc]="cdnBase + '/skinbet_bg.png'" fill />
</div>
<app-top-bar class="top-bar"></app-top-bar>
<!-- @if((uiService.screenSize === 'Large' || uiService.screenSize === 'XLarge' || uiService.screenSize ==='Unknown')) {
<app-navigation class="navigation"></app-navigation>
} -->
<app-navigation-tab-bar class="navigation-tab-bar"></app-navigation-tab-bar>
@if ((uiService.screenSize === 'Small' || uiService.screenSize === 'Medium' || uiService.screenSize === 'XSmall') && uiService.uiStateMobile().browse) {
<app-navigation-tab-browse [@leftSlideIn] class="tab-browse"></app-navigation-tab-browse>
}
<!--  -->
@if ((uiService.screenSize === 'Small' || uiService.screenSize === 'Medium' || uiService.screenSize === 'XSmall') && uiService.uiStateMobile().games) {
<app-navigation-tab-games [@leftSlideIn] class="tab-games"></app-navigation-tab-games>
}
<!--  -->
<app-user-actions></app-user-actions>
<!--  -->
@if (uiService.uiState().chat === 'trimmed' && (uiService.screenSize === 'Large' || uiService.screenSize === 'XLarge' || uiService.screenSize ==='Unknown')) {
<app-chat-message-tooltip></app-chat-message-tooltip>
}
<!--  -->
@if(((uiService.screenSize === 'Large' || uiService.screenSize === 'XLarge' || uiService.screenSize ==='Unknown') && (uiService.uiState().chat === 'open' ||
uiService.uiState().chat === 'trimmed')) || ((uiService.screenSize === 'Small' || uiService.screenSize === 'Medium' || uiService.screenSize === 'XSmall') &&
uiService.uiStateMobile().chat)) {
<app-chat class="chat" [@rightSlideIn]></app-chat>
}
<app-notification class="notification"></app-notification>
<main class="content">
  <div class="router">
    <router-outlet></router-outlet>
  </div>
  <app-footer class="footer"></app-footer>
</main>
@if((uiService.screenSize === 'Large' || uiService.screenSize === 'XLarge' || uiService.screenSize ==='Unknown') && uiService.uiState().chat === 'hidden' ) {
<app-chat-floating-section class="chat-floating-section" />
}
